import React, { useState } from "react";
import api from "../../../../api/client";

const inputStyle = {
  width: "100%", padding: "8px 12px", border: "1px solid #d6dfed",
  borderRadius: 8, fontSize: 14, boxSizing: "border-box",
};
const labelStyle = { display: "block", fontSize: 12, fontWeight: 700, color: "#4f6280", marginBottom: 4 };

export const REASONS = [
  { value: "purchase_receipt", label: "Purchase Receipt" },
  { value: "production_use", label: "Production Use" },
  { value: "adjustment", label: "Adjustment" },
  { value: "return", label: "Return" },
  { value: "damage", label: "Damage" },
];

export function TypeBadge({ type }) {
  const isIn = type === "in";
  return (
    <span style={{
      background: isIn ? "#dcfce7" : "#fee2e2", color: isIn ? "#15803d" : "#dc2626",
      border: `1px solid ${isIn ? "#86efac" : "#fca5a5"}`, borderRadius: 999,
      padding: "2px 10px", fontSize: 11, fontWeight: 800, letterSpacing: "0.4px",
    }}>
      {isIn ? "IN" : "OUT"}
    </span>
  );
}

export default function LogMovementModal({ parts, defaultPartId, onClose, onSaved }) {
  const [partMasterId, setPartMasterId] = useState(defaultPartId || "");
  const [type, setType] = useState("in");
  const [quantity, setQuantity] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [reason, setReason] = useState("purchase_receipt");
  const [referenceNo, setReferenceNo] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSaving(true);
    try {
      await api.post("/manufacturing/inventory/movements", {
        partMasterId, type, quantity: Number(quantity),
        unitPrice: type === "in" && unitPrice !== "" ? Number(unitPrice) : undefined,
        reason, referenceNo: referenceNo || undefined, note: note || undefined,
      });
      onSaved();
    } catch (err) {
      setError(err.response?.data?.error || "Failed to log movement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{ background: "#fff", borderRadius: 14, padding: 28, width: 480, maxHeight: "90vh", overflow: "auto", boxShadow: "0 8px 40px rgba(0,0,0,0.18)", position: "relative" }}>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute", top: 18, right: 18, background: "none", border: "none",
            cursor: "pointer", fontSize: 20, lineHeight: 1, color: "#94a3b8", padding: 4,
          }}
        >
          ×
        </button>
        <h2 style={{ margin: "0 0 20px", fontSize: 18, color: "#0f2d5c", paddingRight: 24 }}>Log Movement</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Part *</label>
            <select style={inputStyle} value={partMasterId} onChange={(e) => setPartMasterId(e.target.value)} required>
              <option value="">— Select part —</option>
              {parts.map((p) => <option key={p.id} value={p.id}>{p.name} ({p.code})</option>)}
            </select>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
            <div>
              <label style={labelStyle}>Type *</label>
              <select style={inputStyle} value={type} onChange={(e) => setType(e.target.value)}>
                <option value="in">IN</option>
                <option value="out">OUT</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Quantity *</label>
              <input style={inputStyle} type="number" min="1" value={quantity} onChange={(e) => setQuantity(e.target.value)} required />
            </div>
          </div>
          {type === "in" && (
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Bought At Price (optional)</label>
              <input style={inputStyle} type="number" min="0" step="0.01" placeholder="e.g. 45.50" value={unitPrice} onChange={(e) => setUnitPrice(e.target.value)} />
            </div>
          )}
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Reason *</label>
            <select style={inputStyle} value={reason} onChange={(e) => setReason(e.target.value)}>
              {REASONS.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
            </select>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
            <div>
              <label style={labelStyle}>Reference #</label>
              <input style={inputStyle} value={referenceNo} onChange={(e) => setReferenceNo(e.target.value)} placeholder="e.g. PO-2026-0042" />
            </div>
            <div>
              <label style={labelStyle}>Note</label>
              <input style={inputStyle} value={note} onChange={(e) => setNote(e.target.value)} />
            </div>
          </div>
          {error && <p style={{ color: "#dc2626", fontSize: 13, marginBottom: 12 }}>{error}</p>}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button type="button" onClick={onClose} style={{ padding: "8px 18px", borderRadius: 8, border: "1px solid #d6dfed", background: "#f8fafc", cursor: "pointer", fontSize: 14 }}>
              Cancel
            </button>
            <button type="submit" disabled={saving} style={{ padding: "8px 20px", borderRadius: 8, background: "#1d4ed8", color: "#fff", border: "none", cursor: saving ? "default" : "pointer", fontWeight: 700, fontSize: 14, opacity: saving ? 0.7 : 1 }}>
              {saving ? "Saving…" : "Log Movement"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
